import httpClient from "@/api/httpClient";
import { IActivityResponse } from "./activity.interface";

export const getActivityService = async (): Promise<IActivityResponse[]> => {
  try {
    const response = await httpClient.get("/v1/activity");
    return response.data;
  } catch (e) {
    throw e;
  }
};
